export default "__VITE_ASSET__CWcRguMq__"